import { render } from "./AurionIcon.vue?vue&type=template&id=4970b9a0"
import script from "./AurionIcon.vue?vue&type=script&lang=js"
export * from "./AurionIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__